// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type DiscoPromoTermsQueryVariables = Types.Exact<{
  input: Types.PromoTermsRequestInput;
}>;


export type DiscoPromoTermsQuery = { __typename?: 'Query', getPromoTerms?: { __typename?: 'PromoTermsResponse', promoType?: string | null, promoCode?: string | null, discount?: number | null, qualifierType?: string | null, currency?: string | null, validFrom?: string | null, validTo?: string | null, message?: string | null, tiers?: Array<{ __typename?: 'PromoTier', tier: number, discount: number, qualifyingAmount: number } | null> | null } | null };


export const DiscoPromoTermsDocument = gql`
    query DiscoPromoTerms($input: PromoTermsRequestInput!) {
  getPromoTerms(input: $input) {
    promoType
    promoCode
    discount
    qualifierType
    currency
    validFrom
    validTo
    tiers {
      tier
      discount
      qualifyingAmount
    }
    message
  }
}
    `;
export type DiscoPromoTermsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<DiscoPromoTermsQuery, DiscoPromoTermsQueryVariables>, 'query'> & ({ variables: DiscoPromoTermsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const DiscoPromoTermsComponent = (props: DiscoPromoTermsComponentProps) => (
      <ApolloReactComponents.Query<DiscoPromoTermsQuery, DiscoPromoTermsQueryVariables> query={DiscoPromoTermsDocument} {...props} />
    );
    

/**
 * __useDiscoPromoTermsQuery__
 *
 * To run a query within a React component, call `useDiscoPromoTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoPromoTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoPromoTermsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDiscoPromoTermsQuery(baseOptions: Apollo.QueryHookOptions<DiscoPromoTermsQuery, DiscoPromoTermsQueryVariables> & ({ variables: DiscoPromoTermsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscoPromoTermsQuery, DiscoPromoTermsQueryVariables>(DiscoPromoTermsDocument, options);
      }
export function useDiscoPromoTermsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscoPromoTermsQuery, DiscoPromoTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscoPromoTermsQuery, DiscoPromoTermsQueryVariables>(DiscoPromoTermsDocument, options);
        }
export function useDiscoPromoTermsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DiscoPromoTermsQuery, DiscoPromoTermsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DiscoPromoTermsQuery, DiscoPromoTermsQueryVariables>(DiscoPromoTermsDocument, options);
        }
export type DiscoPromoTermsQueryHookResult = ReturnType<typeof useDiscoPromoTermsQuery>;
export type DiscoPromoTermsLazyQueryHookResult = ReturnType<typeof useDiscoPromoTermsLazyQuery>;
export type DiscoPromoTermsSuspenseQueryHookResult = ReturnType<typeof useDiscoPromoTermsSuspenseQuery>;
export type DiscoPromoTermsQueryResult = Apollo.QueryResult<DiscoPromoTermsQuery, DiscoPromoTermsQueryVariables>;